<template>
  <div class="tsa-setup-page overflow-x-hide !tw-overflow-y-hidden">
    <div class="container no-padding">
      <div class="row no-margin">
        <TsaSetupHeader
          :dyn-height="dyn_height"
          :window-height="windowHeight"
        />

        <TsaSetupContain />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import $ from "jquery";
import { nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import TsaSetupContain from "./tsaSetup/tsaSetupContain.vue";
import TsaSetupHeader from "./tsaSetup/tsaSetupHeader.vue";

let dyn_height = ref("");
let windowHeight = ref("");

const onResize = () => {
  dyn_height.value = (window.innerHeight + "px") as string;
  windowHeight.value = "" + window.innerHeight + "px !important ";
};

onMounted(() => {
  nextTick(function () {
    window.addEventListener("resize", onResize);
    onResize();
  });

  // document.getElementById("tSASetupModal")?.classList.add("show");
  const body = $("body");
  if (!body.hasClass("page-opacity")) {
    body.addClass("page-opacity page-bg");
  }
});

onBeforeUnmount(() => {
  const body = $("body");
  if (!body.hasClass("page-opacity")) {
    body.addClass("page-opacity page-bg page-shadow");
  }
});
</script>

<style lang="scss" scoped>
.tsa-setup-page {
  background: #0345bd;

  .form-control:focus {
    box-shadow: none;
  }

  .form-control::placeholder {
    color: #b7b7b7;
    font-weight: 300;
    font-size: 22px;
    line-height: 33px;
  }

  .tsa-setup-modal {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    pointer-events: none;
    transform: translate(-50%, -50%);

    .modal-dialog {
      //transition: none;
      min-width: 630px;
    }

    .modal-header {
      border: none;
      margin: 0px 0px 0px 10px;
      justify-content: flex-end;
      .close {
        float: right;
        opacity: 1;
        margin-right: 10px;
        margin-top: 10px;
        position: relative;
        padding: 0;
        z-index: 999;

        img {
          width: 19px;
          height: 19px;
        }
      }
    }

    .modal-content {
      box-shadow: 2px 0px 20px rgba(33, 31, 88, 0.1);
      border-radius: 6px;
      border: none;
    }

    .modal-body {
      padding: 20px 70px 48px 70px;

      .flex-container {
        position: absolute;
        bottom: 0px;
        height: 100%;
      }

      .modal-body-sec1 {
        color: #0345bd;
        font-size: 26px;
        font-weight: 600;
        line-height: 39px;
      }

      .auth-modal-text {
        font-size: 15px;
        color: #231f20;
        line-height: 22px;
        font-weight: 400;
        margin-top: 15px;
      }

      .letsgo-btn {
        margin-top: 35px;
        display: flex;
        align-items: center;
      }

      .input-label-form {
        font-weight: 500;
        font-size: 12px;
        color: #231f20;
        line-height: 18px;
      }

      .authcode-input {
        border: none;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 33px;
        color: #0345bd;
        border-left: 1px solid rgba(183, 183, 183, 0.3);
        border-radius: unset;
        letter-spacing: 0.25em;
      }

      .form-group {
        margin-top: 40px;

        label {
          margin-bottom: 14px;
        }
      }

      .letsgo-button {
        width: 132px;
        height: 45px;
        border-radius: 29.4638px;
        background: #0345bd;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 27px;
        box-shadow: 0px 2.18987px 4.37975px rgba(33, 31, 88, 0.25);
        text-transform: uppercase;
      }

      .letsgo-btn button:disabled {
        color: #ffffff;
        background: #eeeff0;
        border-color: #eeeff0;
      }

      .forgot-text-button {
        font-size: 12px;
        line-height: 27px;
        padding-left: 30px;
        text-decoration-line: underline;
        color: #0345bd;
      }
    }

    .modal-footer {
      background: linear-gradient(
        180deg,
        rgba(230, 230, 230, 0.38) 0%,
        #ffffff 58.06%
      );
      padding: 26px 65px;

      .modal-footer-sec1 {
        line-height: 20.4px;
        font-size: 12px;
      }
    }

    .qr-code {
      display: flex;
      align-items: center;
      padding: 15px 15px 15px 15px;
      margin-top: 40px;
      background: rgba(238, 239, 240, 0.5);
      border: 1px solid #eeeff0;
      box-sizing: border-box;
      border-radius: 4px;
    }

    .qr-code-image {
      background-color: #ffffff;
      padding: 15px;
      border-radius: 4px;

      img {
        width: 155px;
        height: 150px;
      }
    }

    .qr-image {
      position: relative;
      top: 3px;
    }

    .qr-code-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      word-break: break-word;
      padding-left: 30px;
    }

    .helper-text {
      font-size: 12px;
      line-height: 20px;
    }

    .token {
      font-weight: 600;
      font-size: 18px;
      line-height: 27px;
      text-transform: uppercase;
      margin-left: 0px;
      position: relative;
      margin-top: 10px;
    }
  }

  .modal {
    z-index: 1 !important;
  }
}

@media (max-width: 767px) {
  .tsa-setup-page {
    .tsa-setup-modal {
      .modal-header {
        .close {
          margin-top: 3px !important;

          img {
            width: 17px;
            height: 17px;
          }
        }
      }

      .modal-dialog {
        min-width: unset;
      }

      .modal-body {
        padding: 13px 30px 30px 30px;

        .modal-body-sec1 {
          font-size: 22px;
          line-height: 34.5px;
        }

        .form-group {
          margin-top: 24px !important;
        }

        .letsgo-button {
          width: 136px;
          font-size: 16px;
          line-height: 24px;
        }

        .authcode-input {
          font-size: 18px;
          padding-right: 0px;
        }

        .input-label-form {
          font-size: 12px;
          line-height: 18px;
        }

        .forgot-text-button {
          font-size: 12px;
          line-height: 18px;
        }

        .letsgo-btn {
          margin-top: 20px;
        }

        .auth-modal-text {
          font-size: 15px !important;
          line-height: 22px !important;
          margin-top: 8px !important;
        }

        .modal-body-sec1 span {
          display: none;
        }

        .modal-body-sec1:after {
          content: "TFA Authentication";
        }
      }

      .modal-footer {
        padding: 26px 25px;
      }
    }
  }
}

@media (max-height: 500px) {
  .modal {
    padding-top: 50px;
  }
}

@media (min-width: 3840px) {
  .tsa-setup-page {
    .tsa-setup-modal {
      .form-control:focus {
        padding-left: 30px;
        font-size: 38px;
        line-height: 30px;
      }

      .modal-dialog {
        max-width: 1090px !important;
      }

      .modal-body {
        padding: 45px 90px 90px 90px;
      }

      .modal-content {
        border-radius: 15px !important;
      }

      .modal-body-sec1 {
        font-size: 52px !important;
        line-height: 78px !important;
      }

      .form-group {
        margin-top: 35px !important;
      }

      .auth-modal-text {
        font-size: 28px !important;
        line-height: 44px !important;
      }

      .input-label-form {
        font-size: 24px !important;
        line-height: 36px !important;
        margin-bottom: 28px !important;
      }

      .forgot-text-button {
        font-size: 24px !important;
        line-height: 36px !important;
        margin-left: 40px !important;
      }

      .close {
        margin-right: 35px !important;
        margin-top: 40px !important;

        img {
          height: 30px !important;
          width: 30px !important;
          zoom: 1.4;
        }
      }

      .letsgo-btn {
        margin-top: 76px !important;
      }

      .authcode-input {
        font-size: 44px !important;
        padding-left: 30px;
        border-left: 2px solid rgba(183, 183, 183, 0.3) !important;
      }

      .letsgo-button {
        width: 200px !important;
        height: 90px !important;
        font-size: 30px !important;
        border-radius: 41px !important;
      }

      .modal-footer-sec1 {
        line-height: 40.8px !important;
      }

      .modal-footer {
        font-size: 21px !important;
        padding: 35px 105px;
      }
    }
  }
}
</style>
